module.exports = __webpack_public_path__ + "img/robot-swiper-img5.4628a387.png";